import React, { JSX, Suspense } from 'react';
import { generatePath, Route } from 'react-router-dom';
import { QueryLoadingAbsolute } from '@ankr.com/raas-ui';
import { lazily, tCommon } from '@ankr.com/raas-utils';
import { createRouteConfig } from '@ankr.com/utils/createRouteConfig';

import { PROJECT_KEY } from '../common/const/values';
import { AuthGuard } from '../guards';
import { AccountInfoGuard } from '../guards/AccountInfoGuard';
import { LayoutDefault } from '../layout/components/LayoutDefault';

const { Rollup } = lazily(() => import('./screens/Rollup/Rollup'));
const { DeployRollup } = lazily(() => import('./screens/DeployRollup'));

const PATH_ROLLUP = '/chain';
const PATH_DEPLOY = '/chain/deploy';

interface IRollupRouteProps {
  uuid: string;
  success?: boolean;
  failed?: boolean;
}

export const RollupRoutesConfig = createRouteConfig(
  {
    Rollup: {
      path: PATH_ROLLUP,
      generatePath: ({ uuid, success, failed }: IRollupRouteProps) =>
        generatePath(
          `${PATH_ROLLUP}/?uuid=${uuid}${success ? '&success=true' : ''}${failed ? '&failed=true' : ''}`,
        ),
    },
    Deploy: {
      path: PATH_DEPLOY,
      generatePath: () => generatePath(PATH_DEPLOY),
    },
  },
  PATH_ROLLUP,
);

export function getRollupRoutes(): JSX.Element {
  return (
    <>
      <Route
        path={RollupRoutesConfig.Rollup.path}
        element={
          <LayoutDefault title={tCommon('page-title.rollup')}>
            <AuthGuard>
              <AccountInfoGuard>
                <Suspense fallback={<QueryLoadingAbsolute />}>
                  <Rollup />
                </Suspense>
              </AccountInfoGuard>
            </AuthGuard>
          </LayoutDefault>
        }
      />
      <Route
        path={RollupRoutesConfig.Deploy.path}
        element={
          <LayoutDefault
            title={
              PROJECT_KEY === 'asphere-solana'
                ? tCommon('navigation.deploy-chain')
                : tCommon('navigation.deploy-rollup')
            }
          >
            <AuthGuard>
              <AccountInfoGuard>
                <Suspense fallback={<QueryLoadingAbsolute />}>
                  <DeployRollup />
                </Suspense>
              </AccountInfoGuard>
            </AuthGuard>
          </LayoutDefault>
        }
      />
    </>
  );
}
